// The availability choices, shared by the masthead select and the command palette.
import type { Agent } from '@bcio-voice/contracts';

export const AVAILABILITY: readonly { value: Agent['availability']; label: string }[] = [
  { value: 'available', label: 'Available' },
  { value: 'away', label: 'Away' },
  { value: 'do_not_disturb', label: 'Do not disturb' },
  { value: 'offline', label: 'Offline' },
];
